export default "__VITE_ASSET__DG2G1zS5__"